<template>
  <el-form ref="form" :model="form" :inline="true" style="margin-bottom: -18px;" size="mini">
    <el-form-item label="用户账号" prop="userNo">
      <el-input v-model="form.userNo" clearable placeholder="请输入用户账号" size="mini"></el-input>
    </el-form-item>
    <el-form-item label="中文姓名" prop="userName">
      <el-input v-model="form.userName" clearable placeholder="请输入中文姓名" size="mini"></el-input>
    </el-form-item>
    <el-form-item label="英文姓名" prop="userNameEn">
      <el-input v-model="form.userNameEn" clearable placeholder="请输入英文姓名" size="mini"></el-input>
    </el-form-item>
    <el-form-item label="手机号码" prop="prjTitle">
      <el-input v-model="form.mobileNumber" clearable placeholder="请输入手机号码" size="mini"></el-input>
    </el-form-item>
    <el-form-item>
      <el-button style="float: left" type="primary" @click="query">
<!--        <d2-icon name="search" />-->
        查询
      </el-button>
    </el-form-item>
    <el-form-item>
      <el-button style="float: left" @click="reset" class="d2-mr-10">
<!--        <d2-icon name="refresh" />-->
        重置
      </el-button>
    </el-form-item>
  </el-form>
</template>

<script>

export default {
  data () {
    return {
      form: {
        userNo: '',
        userName: '',
        userNameEn: '',
        mobileNumber: ''
      }
    }
  },
  methods: {
    query () {
      this.$emit('submit', this.form)
    },
    reset () {
      this.$refs.form.resetFields()
      this.query()
    }
  }
}
</script>
